angular.module('igs.waitMask', [])

    .directive('igsWaitMask', [
        '$rootScope',
        function ($rootScope) {
            'use strict';
            return {
                restrict: 'E',
                template: '<div id="wait-mask" ng-class="{igsWaitMask: isMasking, igsWaitMaskHidden: !isMasking}"></div>' +
                    '<div id="wait-mask-text" ng-class="{igsWaitMaskHidden: !isMasking}"></div>',
                link: function ($scope) {
                    $scope.isMasking = false;

                    $rootScope.$on('igs-wait-mask-show', function () {
                        $scope.isMasking = true;
                    });

                    $rootScope.$on('igs-wait-mask-hide', function () {
                        $scope.isMasking = false;
                    });
                }
            };
        }
    ])

    .factory('igs.maskingService', [
        '$rootScope',
        '$q',
        function ($rootScope, $q) {
            'use strict';
            var service = {};

            var maskers = 0;

            service.mask = function () {
                maskers++;
                if (maskers >= 1) {
                    $rootScope.$broadcast('igs-wait-mask-show');
                }
            };

            service.unmask = function () {
                maskers--;
                if (maskers === 0) {
                    $rootScope.$broadcast('igs-wait-mask-hide');
                }
            };

            service.isMasked = function () {
                return maskers > 0;
            };

            service.clearMaskOverride = function () {
                maskers = 0;
                $rootScope.$broadcast('igs-wait-mask-hide');
            };

            service.maskFunction = function (fn) {
                service.mask();
                var value = fn();
                service.unmask();
                return value;
            };

            service.maskPromise = function (promise) {
                service.mask();
                return promise.then(function (data) {
                    service.unmask();
                    return data;
                }, function (error) {
                    service.clearMaskOverride();
                    return $q.reject(error);
                });
            };

            return service;
        }
    ]);